<template>
  <div>
    <transition
      name="component-fade"
      mode="out-in"
    >
      <loading-page
        v-if="loading"
        key="loading"
      />
      <div
        v-else
        key="content"
        class="multiparts-body py-1"
      >
        <template v-for="chunk in multipart">
          <div
            :key="chunk.partNumber"
            class="d-flex"
          >
            <div class="chunk">
              <p class="chunk-title ">
                eTag:
              </p>
              <p class="name">
                {{ chunk.eTag }}
              </p>
            </div>
            <div class="chunk">
              <p class="chunk-title text-break">
                Part Number:
              </p>
              <p class="name">
                {{ chunk.partNumber }}
              </p>
            </div>
            <div class="chunk">
              <p class="chunk-title ">
                Size:
              </p>
              <p class="name">
                {{ formatBytes(chunk.size) }}
              </p>
            </div>
          </div>
        </template>
        <template v-if="multipart.length === 0">
          <div
            class="d-flex w-100 jusstify-content-center align-items-center py-2 px-1"
          >
            No multiparts to show...
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'MultipartChunks',
  props: {
    multipart: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.multiparts-body {
  max-height: 400px;
  overflow: auto;
}
.chunk {
  padding: 6px 16px;
  p {
    margin-bottom: 0;
    font-weight: 500;
  }
  .chunk-title {
    font-size: 14px;
    color: #667c99;
    padding: 0;
  }

  .name {
    font-size: 12px;
  }
}
</style>
